
import { Vue, Component, Prop } from "vue-property-decorator";
import {
  SaveAccessorialRequest,
  DeleteAccessorialRequest
} from "../../../models/api/orders/accessorials";
import notifications from "../../../lib/notifications";
import { AccessorialModel } from "@/models/accessorials";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";
import { IOrderResource } from "@/store/types";
import * as modals from "@/lib/modals";
import { SystemModule } from "@/store/modules";

const orderModule = getModule(OrderModule);

@Component({
  name: modals.accessorialChargesModal
})
export default class AccessorialChargesModal extends Vue {
  visible: boolean = false;
  loading: boolean = true;
  accessorials: AccessorialModel[] = null;

  systemModule: SystemModule = getModule(SystemModule);


  @Prop()
  deliveryForId: number;

  get isAgentOrder(): boolean {
    return this.deliveryForId && this.deliveryForId > 0;
  }

  async show() {
    this.visible = true;
    try {
      this.systemModule.loadChargeTypes(this.deliveryForId);
      const response = await orderModule.getOrderAccessorials(orderModule.currentOrder.number);
      this.accessorials = response.map(x => AccessorialModel.fromApiResource(x));
    } catch (ex) {
      notifications.error("Accessorials", "Failed to load accessorials", ex);
    }

    this.loading = false;
  }

  

  hide() {
    this.visible = false;
    this.loading = true;
    this.accessorials = null;
  }

  addRow() {
    this.accessorials.push(new AccessorialModel());
  }

  get currentOrder(): IOrderResource {
    return orderModule.currentOrder;
  }

  get accessorialTotalInDollars() {
    return this.formatMoney(
      this.accessorials.map(x => x.quantity * x.rate).reduce((prev, current) => prev + current, 0),
      2
    );
  }

  get accessorialCount() {
    return this.accessorials.length;
  }

  get taxItemCount() {
    return 0;
  }

  get totalTaxes() {
    return this.formatMoney(0, 2);
  }

  async save(accessorial: AccessorialModel) {
    const request: SaveAccessorialRequest = {
      id: accessorial.id,
      description: accessorial.description,
      chargeType: accessorial.itemCode,
      quantity: Number(accessorial.quantity),
      orderNumber: orderModule.currentOrder.headerNumber,
      rate: Number(accessorial.rate),
      fixAll: accessorial.fixAll
    };

    try {
      accessorial.saving = true;
      await orderModule.saveAccessorial(request).then((response: any) => {
        if (!response.id) {
          console.warn("response void");
        }
        accessorial.id = response.id;
        notifications.success("Save Accessorial", "Accessorial successfully saved");
      });
    } catch (ex) {
      notifications.error("Save Accessorial", "Failed to save accessorial", ex);
    }

    accessorial.saving = false;
  }

  async remove(accessorial: AccessorialModel) {
    const request: DeleteAccessorialRequest = {
      id: accessorial.id,
      orderNumber: orderModule.currentOrder.headerNumber
    };

    try {
      accessorial.saving = true;
      await orderModule.deleteAccessorial(request).then(() => {
        notifications.success("Removed Accessorial", "Accessorial successfully removed");
        let index = this.accessorials.indexOf(accessorial);
        if (index >= 0) this.accessorials.splice(index, 1);
      });
    } catch (ex) {
      notifications.error("Removed Accessorial", "Failed to remove accessorial", ex);
    }
    accessorial.saving = false;
  }
}
